import { apiAction } from '../../../../shared/store/apiAction';

import * as api from './api';
import { fetchFederalReconciliationVariancesTypes } from './types';

export const fetchFederalReconciliationVariances = apiAction({
  types: fetchFederalReconciliationVariancesTypes,
  apiAction: api.fetchFederalReconciliationVariances,
});
